import { render, staticRenderFns } from "./StepA1_2.vue?vue&type=template&id=4f2af71c&lang=html&"
import script from "./StepA1_2.vue?vue&type=script&lang=js&"
export * from "./StepA1_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports